import { render, staticRenderFns } from "./SelectionError.vue?vue&type=template&id=5a54b81f&scoped=true&lang=pug&"
import script from "./SelectionError.vue?vue&type=script&lang=js&"
export * from "./SelectionError.vue?vue&type=script&lang=js&"
import style0 from "./SelectionError.vue?vue&type=style&index=0&id=5a54b81f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54b81f",
  null
  
)

export default component.exports